import React from 'react'
import { Container } from '../../../../../../components/Container'
import { Tooltip, Typography, useTheme } from '@material-ui/core'
import { ChatMessageContent, HelpVideo, HowToResponse } from '../../../types'
import { TrainingVideoController } from '../../../../../../hooks/useTrainingVideo'
import { typographyStyle } from '../../../../../../theme/typographyStyle'

interface VideoCardProps {
    message: ChatMessageContent
    trainingVideoController: TrainingVideoController
}

export const VideoCard = ({
    message,
    trainingVideoController,
}: VideoCardProps) => {
    if (!message.function_call_response) {
        return null
    }

    const video = message.function_call_response as HelpVideo
    console.log('video', video)

    const theme = useTheme()
    const formatDuration = (seconds: number): string => {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
    }
    const handleVideoClick = () => {
        window.open(video.video_url, '_blank')
        trainingVideoController.addVideoView(video.id)
    }
    return (
        <Container
            style={{
                display: 'flex',
                flexDirection: 'column',
                border: `1px solid ${theme.palette.divider}`,
            }}
        >
            {/* Main video */}
            <Container
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: theme.spacing(2),
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    cursor: 'pointer',
                    // backgroundColor: 'blue',
                }}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#f0f0f0'
                    e.currentTarget.style.transform = 'translateY(-1px)'
                    e.currentTarget.style.boxShadow =
                        '0 2px 4px rgba(0,0,0,0.05)'
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#fafafa'
                    e.currentTarget.style.transform = 'translateY(0)'
                    e.currentTarget.style.boxShadow = 'none'
                }}
                onClick={handleVideoClick}
            >
                {/* Thumbnail */}
                <div
                    style={{
                        width: 120,
                        minWidth: 120,
                        height: 67, // 16:9 aspect ratio
                        marginRight: theme.spacing(2),
                        position: 'relative',
                    }}
                >
                    <img
                        src={video.thumbnail}
                        alt={video.title}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: theme.shape.borderRadius,
                        }}
                    />
                    {/* Duration overlay */}
                    <Typography
                        variant="caption"
                        style={{
                            position: 'absolute',
                            bottom: 4,
                            right: 4,
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            color: 'white',
                            padding: '2px 4px',
                            borderRadius: 2,
                        }}
                    >
                        {video.duration}
                    </Typography>
                </div>

                {/* Text content */}
                <Tooltip
                    title={
                        <div>
                            <Typography
                                style={{
                                    ...typographyStyle(theme.typography.body2),
                                }}
                            >
                                Key Topics:
                            </Typography>
                            <ul style={{ margin: '4px 0', paddingLeft: 16 }}>
                                {Array.isArray(video.key_topics) ? (
                                    video.key_topics.map((topic, index) => (
                                        <li
                                            style={{
                                                ...typographyStyle(
                                                    theme.typography.body2,
                                                ),
                                                marginBottom: theme.spacing(
                                                    0.5,
                                                ),
                                            }}
                                            key={index}
                                        >
                                            {topic}
                                        </li>
                                    ))
                                ) : (
                                    <li>No key topics available</li>
                                )}
                            </ul>
                        </div>
                    }
                >
                    <div>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontWeight: 500,
                                marginBottom: theme.spacing(0.5),
                            }}
                        >
                            {video.title}
                        </Typography>
                    </div>
                </Tooltip>
            </Container>
        </Container>
    )
}
